// AI-CONTEXT: See docs/features/impact-per-euro-methodiek.md
// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
import { useHistory } from 'react-router-dom'
import { client } from '../../hooks/Client'
import formatEuro from '../../helpers/formatEuro'
import useImpactPerEuroRatio from '../../hooks/useImpactPerEuroRatio'
import StaticCardLabel from './StaticCardLabel'
import KpiValue from './KpiValue'
import notAttributedText from '../../helpers/msiMonetisationHelpers/notAttributedText'

/**
 * Compact KPI tile: impact per euro volgens methodiek v1.0. De volledige
 * berekening (boekjaar, teller, noemer, status, versielabel) leeft in de
 * gedeelde hook useImpactPerEuroRatio — dezelfde bron als de Impact in
 * beeld-hub, zodat kaart en hub altijd hetzelfde getal tonen. Toont "—" plus
 * reden zodra vaststaat dat er geen presenteerbaar kengetal is — nooit een
 * vals getal, en zolang de stromen nog binnenkomen een laadindicator in plaats
 * van dat streepje.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 */
const DashboardImpactPerEuroCard = () => {
    const history = useHistory()
    const { result, label, loading, errorMessage, notAttributedCount, notAttributedReasons } = useImpactPerEuroRatio()
    // Methodiek § 6.3: wat niet doorgerekend kon worden, staat bij het getal (#344).
    const notAttributedNote = !loading && notAttributedCount > 0
        ? <p className='impact-per-euro-kpi-note'>{notAttributedText(notAttributedCount, notAttributedReasons)}</p>
        : null

    return (
        <div
            className='participation-value-card participation-value-card--clickable'
            role='button'
            tabIndex={0}
            onClick={() => history.push(`/${client}/impact-per-euro`)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    history.push(`/${client}/impact-per-euro`)
                }
            }}
        >
            <StaticCardLabel title='Impact per euro' />
            {errorMessage ? (
                <p className='participation-value-error'>{errorMessage}</p>
            ) : !result || result.kengetal === null ? (
                <>
                    <KpiValue loading={loading} value={null} />
                    {!loading && result?.status === 'onvoldoende' && result.reden &&
                        <p className='impact-per-euro-kpi-reason'>{result.reden}</p>}
                    {notAttributedNote}
                </>
            ) : (
                <>
                    <KpiValue loading={loading} value={formatEuro(result.kengetal)} />
                    {!loading && <p className='impact-per-euro-kpi-label'>{label}</p>}
                    {notAttributedNote}
                </>
            )}
            <span className='participation-value-more'>Meer info →</span>
        </div>
    )
}

export default DashboardImpactPerEuroCard
